/*
 * O fundo da página, escolhido no admin (src/Backgrounds): o do fórum e o das
 * páginas de entrar/cadastrar. Mora em classes no <html> (`CanelaBg--<estilo>`)
 * e, com imagem, na variável `--cn-bg-image`. O PreBootShell aplica o mesmo
 * antes da primeira pintura; aqui ele é refeito no boot e trocado ao entrar e
 * sair das páginas de entrar/cadastrar.
 */
import app from 'flarum/forum/app';
import { previewState } from './preview';
const STYLES = ['tinted', 'gradient', 'solid', 'plain', 'image'];
function attr(name) {
  return String(app.forum?.attribute(name) ?? '');
}
function asStyle(value, fallback) {
  return STYLES.includes(value) ? value : fallback;
}
function imageUrl(path) {
  if (!path) return null;
  return `${attr('assetsBaseUrl').replace(/\/$/, '')}/${path}`;
}
export function forumBackground() {
  const style = asStyle(previewState()?.forumBackground ?? attr('canelaForumBackground'), 'tinted');
  return {
    style,
    image: style === 'image' ? imageUrl(attr('canelaForumBackgroundImage')) : null
  };
}
export function authBackground() {
  const value = previewState()?.authBackground ?? attr('canelaAuthBackground');
  if (!STYLES.includes(value)) return forumBackground();
  const style = value;
  return {
    style,
    image: style === 'image' ? imageUrl(attr('canelaAuthBackgroundImage')) : null
  };
}
export function applyBackground(context) {
  const {
    style,
    image
  } = context === 'auth' ? authBackground() : forumBackground();
  const root = document.documentElement;
  STYLES.forEach(name => root.classList.toggle(`CanelaBg--${name}`, name === style && (name !== 'image' || !!image)));

  // Imagem escolhida e ainda não enviada: fica o liso, sem fundo quebrado.
  if (style === 'image' && !image) root.classList.add('CanelaBg--plain');
  if (image) root.style.setProperty('--cn-bg-image', `url(${JSON.stringify(image)})`);else root.style.removeProperty('--cn-bg-image');
}
flarum.reg.add('ramon-canela', 'forum/shell/backgrounds', { forumBackground: forumBackground,authBackground: authBackground,applyBackground: applyBackground, });